import LockIcon from '@mui/icons-material/Lock';
import { Box, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ErrorContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  padding: 0.5rem;
  border-radius: 3px;
  background-color: #f9f9f9;
  border: 1px solid #e8e8e8;
  width: 100%;
  height: 100%;
  min-height: 2rem;
`;

const StyledLockIcon = styled(LockIcon)<{
  $isTooltip?: boolean;
  $whiteIcon?: boolean;
}>`
  color: ${(props) => (props.$whiteIcon ? '#ffffff' : '#757575')};
  font-size: ${(props) =>
    props.$isTooltip ? 'clamp(1.5rem, 4vw, 3rem)' : '1rem'};
  cursor: ${(props) => (props.$isTooltip ? 'pointer' : 'default')};
  &:hover {
    color: ${(props) =>
      props.$isTooltip
        ? props.$whiteIcon
          ? '#f5f5f5'
          : '#616161'
        : props.$whiteIcon
          ? '#ffffff'
          : '#757575'};
  }
`;

const ErrorText = styled(Typography)`
  color: #424242;
  font-size: 0.75rem;
  margin: 0;
  line-height: 1.2;
`;

const TooltipContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0.25rem;
`;

export interface InsufficientPermissionsProps {
  className?: string;
  variant?: 'inline' | 'tooltip';
  whiteIcon?: boolean;
}

export const InsufficientPermissions: React.FC<
  InsufficientPermissionsProps
> = ({ className, variant = 'tooltip', whiteIcon = false }) => {
  const { t } = useTranslation();

  if (variant === 'inline') {
    return (
      <ErrorContainer className={className}>
        <StyledLockIcon $isTooltip={false} $whiteIcon={whiteIcon} />
        <ErrorText variant="body2">
          {t('pages:componentErrors.insufficientPermissions')}
        </ErrorText>
      </ErrorContainer>
    );
  }

  return (
    <TooltipContainer className={className}>
      <Tooltip title={t('pages:componentErrors.insufficientPermissions')} arrow>
        <StyledLockIcon $isTooltip={true} $whiteIcon={whiteIcon} />
      </Tooltip>
    </TooltipContainer>
  );
};

export default InsufficientPermissions;
